var $3c7c19d9b7d666e6$exports = {};
$3c7c19d9b7d666e6$exports = {
    "invalidSelection": (args, formatter)=>`${formatter.plural(args.selectedCount, {
            one: `Vybran\xe9 datum nen\xed`,
            other: `Vybran\xe1 data nejsou`
        })} k dispozici.`
};


export {$3c7c19d9b7d666e6$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
